import {
    postNewRouteLoading,
    postNewRouteRequest,
    postNewRouteSuccess,
    postNewRouteReject,
    postNewRouteReset
} from "../../actions/importRoute/post";

export const postNewRoute = (formData) => async (dispatch, getState) => {
    dispatch(postNewRouteLoading());
    try {
        const { data } = await postNewRouteRequest(formData, getState);
        dispatch(postNewRouteSuccess(data))
    } catch (error) {
        dispatch(postNewRouteReject(error))
    } finally {
        setTimeout(() => { dispatch(postNewRouteReset()) }, 3000);
    }
    return Promise.resolve();
};